var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-toolbar',{staticClass:"mb-3 secondary",attrs:{"elevation":"1","dense":"","rounded":""}},[_c('v-breadcrumbs',{attrs:{"large":"","items":[{text:'Administration'},{text:'Stock Journal'},{text:'Roles'}]}})],1),_c('StockJournalRolesList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }